import axios from 'axios';

import { parameters } from '../../constants/parameters';
import { E2rRequest } from '../../entities/e2r-request';
import * as genericApi from './generic-api';

const url = `${parameters.api.baseUrl}/easy-2-read`;

export const list = async (token: string): Promise<E2rRequest[]> => {
  return genericApi.listWithoutPagination<E2rRequest>(token, url, { limit: 30 });
};

export const one = async (token: string, id: number): Promise<E2rRequest> => {
  return genericApi.one<E2rRequest>(token, `${url}/${id}`);
};

export const create = async (
  token: string,
  title: string,
  body: string,
): Promise<{ requestId: number; status: string }> => {
  return genericApi.create<{ title: string; body: string }, { requestId: number; status: string }>(token, url, {
    title,
    body,
  }) as Promise<{ requestId: number; status: string }>;
};

export const destroy = async (token: string, id: number): Promise<{ status: string }> => {
  const response = await axios.delete(`${url}/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

export const retry = async (token: string, id: number): Promise<{ requestId: number; status: string }> => {
  const response = await axios.post(
    `${url}/${id}/retry`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  return response.data;
};

export const downloadWord = async (token: string, id: number): Promise<Blob> => {
  return genericApi.blob(token, `${url}/${id}/download-word`);
};
